import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Card, Container, Typography } from '@material-ui/core';
import { Col } from 'components/Col';
import { Row } from 'components/Row';
import { CustomCheckbox } from 'components/CustomCheckbox';
import useValidations from '../hooks/useValidations';
import CustomMultipleSelect from 'components/CustomMultipleSelect/CustomMultipleSelect';
import { CustomTextField } from 'components/CustomTextField';
import { diferenceMonths } from 'utils/DateUtils';
import { allProgramas } from 'models/escola';
import { RootState } from 'store';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import SnackbarUtils from 'utils/SnackbarUtils';
import { loadCidadesByEstadoId, loadEstados } from 'store/modules/LogradouroActions';
import { useLocation, useParams } from 'react-router-dom';
import { CreateRouteParams, EditRouteParams } from '../__types';
import { changeContratoEntePrivadoEditingValue } from 'store/modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoActions';
import { loadEscolasPorCidadesECodCoopFluxoContratos } from 'store/modules/EscolasActions';
import { loadAllProfessorGestorByEscola } from 'store/modules/ProfessoresActions';
import { CONTRATO_ETAPAS_PARAMS_URL } from 'models/contratos';
import { DateMaskedInput } from 'components/MaskedInputs';
import '../index.scss'
import { AlturaMenuEnum } from 'components/CustomMultipleSelect/__types';
interface Cidade {
  nome: string;
}
interface Escola {
  id: number;
  nome: string;
  coop?: string;
  cidadeNome?: string | null;
  estadoId?: string | null;
}

export const ContratoEntePrivadoDescentralizado = () => {
  const [idEstadoSelect, setIdEstadoSelect] = useState(false);
  const [showCampoEstadoECidade, setShowCampoEstadoECidade] = useState(false);
  const [isCidadeSelected, setIsCidadeSelected] = useState(false);
  const [dataInicioError, setDataInicioError] = useState('');
  const [dataFimError, setDataFimError] = useState('');
  const [loadingEstados, setLoadingEstados] = useState(false);
  const [isEscolaSelected, setIsEscolaSelected] = useState(false);
  const contratosEntePrivadoReducer = useSelector((state: RootState) => state.contratosDescentralizadosEntePrivado.contratoEditing);
  const languageValues = useSelector((state: RootState) => state.languages.languageValues);
  const logradouro = useSelector((state: RootState) => state.logradouro);
  const escolas = useSelector((state: RootState) => state.escolas);
  const professoresReducer = useSelector((state: any) => state.professores)
  const {
    isContratoAtivoEntePrivado,
    validateDataInicio,
    validateDataFim,
    dataInicioIsValid,
    dataFimIsValid,
    validaStatusContratoFluxo,
    valueProgramaEducacionaisIsValid,
    validaValorNomeEstado,
    validaValorNomeCidade,
    validaValorCampoEscola,
    validaValorCampoRepresentante,
    desabilitaCampoCidade
  } = useValidations();
  const params = useParams<CreateRouteParams & EditRouteParams>();
  const idContrato = params.id;
  const dispatch = useDispatch();
  const location = useLocation();

  const handleDataChange = useCallback((name, value) => {
    dispatch(changeContratoEntePrivadoEditingValue(name, value));
  }, [dispatch])

  const handleEstadoChange = (value: { value: number }) => {
    const currValue = value && value.value > -1 ? value.value : -1;
    handleDataChange('idEstado', currValue);
    if (value) {
      loadCidades(currValue);
      setIdEstadoSelect(true);
    } else {
      setIdEstadoSelect(false);
      setIsEscolaSelected(false);
    }
    handleDataChange('nomCidade', '');
    handleDataChange('cpfProfessor', '');
    handleDataChange('idEscola', '')
    handleDataChange('nomEscola', '');
  };

  const handleCidadeChange = (value: { value: string, label: string }) => {
    const currValue = value ? value.value : '';
    handleDataChange('nomCidade', currValue);
    if (currValue) {
      loadEscolas(value.label);
      setIsCidadeSelected(true);
    } else {
      setIsCidadeSelected(false);
      setIsEscolaSelected(false)
      handleDataChange('cpfProfessor', '');
    }
    handleDataChange('nomEscola', '');
    handleDataChange('idEscola', '');
    handleDataChange('cpfProfessor', '');
  };

  const handleEscolaChange = (value: { value: string, label: string }) => {
    const currValue = value ? value.value : '';
    handleDataChange('nomEscola', currValue);
    handleDataChange('idEscola', currValue)
    if (currValue) {
      loadRepresentantes(Number(currValue))
      setIsEscolaSelected(true)
      handleDataChange('nomEscola', value.label)
    } else {
      setIsEscolaSelected(false)
      handleDataChange('nomEscola', '');
      handleDataChange('idEscola', '')
      handleDataChange('cpfProfessor', '');
      setIsEscolaSelected(!!value);
      if (idContrato && location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.EDICAO)) {
        setShowCampoEstadoECidade(true);
        if (isCidadeSelected === true) {
          setIsEscolaSelected(false)
          handleDataChange('idEscola', '')
          handleDataChange('nomEscola', '');
          handleDataChange('cpfProfessor', '');
        } else {
          handleDataChange('idEstado', 0);
          setIdEstadoSelect(false);
        }
      }
    }
  };

  const handleRepresentanteChanged = (value: { value: string }) => {
    const currValue = value ? value.value : '';
    handleDataChange('cpfProfessor', currValue);
  }

  const getUFByIdEstado = (idEstadoParam: number | null): string => {
    const estadoV = logradouro.estados.find((estado) => estado.id === idEstadoParam);
    return estadoV ? estadoV.sigla : '';
  };

  const loadEstadosAll = () => {
    setLoadingEstados(true);
    dispatch(loadEstados(
      () => {
        setLoadingEstados(false);
        if (contratosEntePrivadoReducer.idEstado) {
          loadCidades(contratosEntePrivadoReducer.idEstado);
        }
      },
      (error: any) => {
        setLoadingEstados(false);
        SnackbarUtils.enqueueSnackbar({
          message: error.response.statusText || languageValues.errorLoadEstados,
          options: {
            variant: 'error',
          },
        });
      }
    ));
  };

  const getCidades = (uf: string): Cidade[] => {
    if (!uf) {
      return [];
    }
    return logradouro.cidades[uf.toLowerCase()] || [];
  };

  const loadCidades = (idEstado: number) => {
    const uf = getUFByIdEstado(idEstado);
    if (uf && getCidades(uf).length === 0) {
      dispatch(loadCidadesByEstadoId(idEstado, uf));
    }
  };

  const onDataInicioChanged = (value: string) => {
    const error = validateDataInicio(
      value,
      contratosEntePrivadoReducer.dataFim,
      {
        after: languageValues.dataInicioError,
        same: languageValues.dataInicioIgualDataFimError,
      }
    );
    setDataInicioError(error);

    if (!error) {
      setDataInicioError('');
    }

    let months: unknown = diferenceMonths(
      value,
      contratosEntePrivadoReducer.dataFim
    );
    if (typeof months === 'string') {
      months = parseFloat(months);
    }
    if (isNaN(months as number)) {
      months = 0;
    }
    handleDataChange('totalMeses', Math.max(months as number, 0));
  };

  const onDataFimChanged = (value: string) => {
    const error = validateDataFim(
      value,
      contratosEntePrivadoReducer.dataInicio,
      {
        before: languageValues.dataFimError,
        same: languageValues.dataFimIgualDataInicioError,
      }
    );
    setDataFimError(error);

    if (!error) {
      setDataFimError('');
    }
    const dataInicioErrorValue = validateDataInicio(
      contratosEntePrivadoReducer.dataInicio,
      value,
      {
        after: languageValues.dataInicioError,
        same: languageValues.dataInicioIgualDataFimError,
      }
    );
    setDataInicioError(dataInicioErrorValue);

    let months: unknown = diferenceMonths(
      contratosEntePrivadoReducer.dataInicio,
      value
    );
    if (typeof months === 'string') {
      months = parseFloat(months);
    }
    if (isNaN(months as number)) {
      months = 0;
    }
    handleDataChange('totalMeses', Math.max(months as number, 0));
  };

  const dataInicioValidacaoResultado = dataInicioIsValid(
    contratosEntePrivadoReducer.dataInicio,
    contratosEntePrivadoReducer.dataFim,
    {
      after: languageValues.dataInicioError,
      same: languageValues.dataInicioIgualDataFimError,
    }
  );

  const dataFimValidacaoResultado = dataFimIsValid(
    contratosEntePrivadoReducer.dataFim,
    contratosEntePrivadoReducer.dataInicio,
    {
      before: languageValues.dataFimError,
      same: languageValues.dataFimIgualDataInicioError,
    }
  );

  const loadEscolas = (cidade: string) => {
    const codCoop = contratosEntePrivadoReducer.codCoop;  
    if (cidade && codCoop) {
      dispatch(loadEscolasPorCidadesECodCoopFluxoContratos([cidade], codCoop));
    }
  };

  const loadRepresentantes = (idEscola: number) => {
    if (idEscola) {
      dispatch(loadAllProfessorGestorByEscola(idEscola))
    }
  };

  const getEscolas = (): Escola[] => {
    if (contratosEntePrivadoReducer.nomCidade) {
      return (escolas.escolasPorCidade as unknown as Escola[]) || [];
    }
    if (idContrato) {
      return contratosEntePrivadoReducer.nomEscola ? [{ nome: contratosEntePrivadoReducer.nomEscola, id: contratosEntePrivadoReducer.idEscola }] : [];
    }
    return [];
  };

  const getRepresentantes = () => {
    if (contratosEntePrivadoReducer.cpfProfessor) {
      return professoresReducer.professoresGestoresByEscola || [];
    }
    if (contratosEntePrivadoReducer.idEscola) {
      return professoresReducer.professoresGestoresByEscola || [];
    }
    return [];
  };

  const mensagemErroCampoEstado = () => {
    return !validaValorNomeEstado(contratosEntePrivadoReducer.idEstado).status
      ? validaValorNomeEstado(contratosEntePrivadoReducer.idEstado).error
      : ''
  }

  const mensagemErroCampoCidade = () => {
    return !desabilitaCampoCidade(contratosEntePrivadoReducer.idEstado < 1) &&
      !validaValorNomeCidade(contratosEntePrivadoReducer.nomCidade).status
      ? validaValorNomeCidade(contratosEntePrivadoReducer.nomCidade).error
      : ''
  }

  const mensagemErroCampoEscola = () => {
    return isCidadeSelected && idEstadoSelect &&
      !validaValorCampoEscola(contratosEntePrivadoReducer.nomEscola, !isCidadeSelected).status
      ? validaValorCampoEscola(contratosEntePrivadoReducer.nomEscola, !isCidadeSelected).error
      : ''
  }

  const mensagemCampoErroRepresentante = () => {
    return isEscolaSelected &&
      !validaValorCampoRepresentante(contratosEntePrivadoReducer.cpfProfessor, !isEscolaSelected).status
      ? validaValorCampoRepresentante(contratosEntePrivadoReducer.cpfProfessor, !isEscolaSelected).error
      : ''
  }

  const mensagemCampoProgramasEducacionais = () => {
    return !valueProgramaEducacionaisIsValid().status
      ? valueProgramaEducacionaisIsValid().error
      : ''
  }

  const desabilitaCampoEscola = () => {
    if (location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.CADASTRO)) {
      return (!isCidadeSelected || !idEstadoSelect) || (!isContratoAtivoEntePrivado() || !validaStatusContratoFluxo());
    }
    if (location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.EDICAO)) {
      return showCampoEstadoECidade && (!isCidadeSelected || !idEstadoSelect);
    }
    return true;
  }

  const desabilitaCampoRepresentantes = () => {
    if (location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.CADASTRO)) {
      return !isEscolaSelected || !idEstadoSelect || !isCidadeSelected;
    }
    if (location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.EDICAO)) {
      return showCampoEstadoECidade && (!isEscolaSelected || !idEstadoSelect || !isCidadeSelected);
    }
    return true;
  }

  useEffect(() => {
    loadEstadosAll();
    // eslint-disable-next-line 
  }, []);

  useEffect(() => {
    if (contratosEntePrivadoReducer.idEscola) {
      dispatch(loadAllProfessorGestorByEscola(contratosEntePrivadoReducer.idEscola));
    }
  }, [contratosEntePrivadoReducer.idEscola, dispatch]);

  useEffect(() => {
    if (location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.CADASTRO)) {
      setShowCampoEstadoECidade(true);
    }
    else if (idContrato && location.pathname.includes(CONTRATO_ETAPAS_PARAMS_URL.EDICAO)) {
      setShowCampoEstadoECidade(false);
    }
  }, [idContrato, location.pathname]);

  return (
    <Container className='componentsDescentralizado__container'>
      <Box className='componentsDescentralizado__box'>
        <Typography variant='h5' className='componentsDescentralizado__title'>
          {languageValues.dadosContratante}
        </Typography>
        <Typography variant='h5' className='componentsDescentralizado__sub'>
          {languageValues.preenchaDadosContratanteEntePrivado}
        </Typography>
      </Box>

      <Card className='componentsDescentralizado__card'>
        <Box>
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <Typography variant='h5' id="dadosEntePrivado"
                className='componentsDescentralizado__tipo-contrato-title'>
                {languageValues.cadastroContratoDadosEntePrivado}
              </Typography>
            </Col>
          </Row>
          {showCampoEstadoECidade && (
            <>
              <Row>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <NewAutoCompleteField
                    id="estado"
                    label={languageValues.estado}
                    placeholder={loadingEstados ? languageValues.loadingEstados : ''}
                    options={logradouro.estados.map((item) => ({
                      label: item.nome,
                      value: item.id,
                      sigla: item.sigla,
                    }))}
                    value={contratosEntePrivadoReducer.idEstado}
                    onChange={handleEstadoChange}
                    loading={logradouro.loadingAllEstadosByCoops}
                    loadingMessage={languageValues.loadingEstados}
                    helperText={mensagemErroCampoEstado()}
                    error={!validaValorNomeEstado(contratosEntePrivadoReducer.idEstado).status}
                    disabled={
                      loadingEstados ||
                      !isContratoAtivoEntePrivado() ||
                      !validaStatusContratoFluxo()
                    }
                  />
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <NewAutoCompleteField
                    id="cidade"
                    label={languageValues.cidade}
                    placeholder={logradouro.loadingCidades ? languageValues.loadingCidades : ''}
                    options={getCidades(getUFByIdEstado(contratosEntePrivadoReducer.idEstado)).map((item) => ({
                      label: item.nome,
                      value: item.nome,
                    }))}
                    value={contratosEntePrivadoReducer.nomCidade}
                    onChange={handleCidadeChange}
                    loading={logradouro.loadingCidades}
                    loadingMessage={languageValues.loadingCidades}
                    helperText={mensagemErroCampoCidade()}
                    error={!desabilitaCampoCidade(contratosEntePrivadoReducer.idEstado < 1) &&
                      !validaValorNomeCidade(contratosEntePrivadoReducer.nomCidade).status}
                    disabled={
                      !isContratoAtivoEntePrivado() ||
                      !validaStatusContratoFluxo() ||
                      desabilitaCampoCidade(contratosEntePrivadoReducer.idEstado < 1)}
                  />
                </Col>
              </Row>
            </>
          )}

          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <NewAutoCompleteField
                id="nomEscola"
                label={languageValues.escola}
                options={getEscolas().map((item: Escola) => ({
                  label: item.nome,
                  value: item.id,
                }))}
                value={contratosEntePrivadoReducer.idEscola}
                onChange={handleEscolaChange}
                helperText={mensagemErroCampoEscola()}
                error={
                  isCidadeSelected && idEstadoSelect &&
                  !validaValorCampoEscola(contratosEntePrivadoReducer.nomEscola, !isCidadeSelected).status
                }
                disabled={desabilitaCampoEscola() || !isContratoAtivoEntePrivado()}
              />
            </Col>
            <Col cols={[12, 12, 6, 6, 6]}>
              <NewAutoCompleteField
                id={'representanteGestor'}
                label={languageValues.representantesLabel}
                options={getRepresentantes().map((item: { nome: string, cpf: string }) => ({
                  label: item.nome,
                  value: item.cpf,
                }))}
                value={contratosEntePrivadoReducer.cpfProfessor}
                onChange={handleRepresentanteChanged}
                helperText={mensagemCampoErroRepresentante()}
                error={
                  isEscolaSelected &&
                  !validaValorCampoRepresentante(contratosEntePrivadoReducer.cpfProfessor, !isEscolaSelected).status
                }
                disabled={desabilitaCampoRepresentantes() || !isContratoAtivoEntePrivado()}
              />
            </Col>
          </Row>

          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <Typography
                variant='h5' id="dadosEntePrivado"
                className='componentsDescentralizado__tipo-contrato-title'>
                {languageValues.cadastroContratoDadosContrato}
              </Typography>
            </Col>
          </Row>
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              <CustomMultipleSelect
                id={'programas-educacionais'}
                label={languageValues.programasEducacionais}
                options={allProgramas() && allProgramas().map((item) => ({
                  label: item.description,
                  value: item.value,
                }))}
                multiple
                value={contratosEntePrivadoReducer.programasEducacionais}
                onChange={(value) => {
                  handleDataChange('programasEducacionais', value);
                }}
                error={!valueProgramaEducacionaisIsValid().status}
                helperText={mensagemCampoProgramasEducacionais()}
                disabled={
                  !isContratoAtivoEntePrivado() ||
                  !validaStatusContratoFluxo()}
                menuMaxHeight={{
                  desktop: AlturaMenuEnum.full,
                  tablet: AlturaMenuEnum.full,
                  mobile: AlturaMenuEnum.full
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={'data-inicio'}
                label={languageValues.cadastroContratoDataInicio}
                name='dataInicio'
                value={contratosEntePrivadoReducer.dataInicio}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const value = event.target.value.trim();
                  handleDataChange('dataInicio', value);
                  if (value.length === 10) {
                    onDataInicioChanged(value);
                  } else {
                    setDataInicioError('');
                  }
                }}
                InputProps={{
                  inputComponent: DateMaskedInput,
                }}
                helperText={
                  dataInicioError ||
                  (!dataInicioValidacaoResultado.status ? dataInicioValidacaoResultado.error : '')
                }
                error={!dataInicioValidacaoResultado.status || !!dataInicioError}
                disabled={
                  !isContratoAtivoEntePrivado() ||
                  !validaStatusContratoFluxo()}
              />
            </Col>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomTextField
                id={'data-fim'}
                label={languageValues.cadastroContratoDataFim}
                name='dataFim'
                value={contratosEntePrivadoReducer.dataFim}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const value = event.target.value.trim();
                  handleDataChange('dataFim', value);
                  if (value.length === 10) {
                    onDataFimChanged(value);
                  } else {
                    setDataFimError('');
                  }
                }}
                InputProps={{
                  inputComponent: DateMaskedInput,
                }}
                helperText={
                  dataFimError ||
                  (!dataFimValidacaoResultado.status ? dataFimValidacaoResultado.error : '')
                }
                error={!dataFimValidacaoResultado.status || !!dataFimError}
                disabled={
                  !isContratoAtivoEntePrivado() ||
                  !validaStatusContratoFluxo()} />
            </Col>
          </Row>

          <Row className="componentsDescentralizado__row-content">
            <Col cols={[12, 12, 6, 6, 6]}>
              <div className='componentsDescentralizado__label-total-meses'>
                {languageValues.totalMesesContratados}
              </div>
              <div className='componentsDescentralizado__value-total-meses'>
                {contratosEntePrivadoReducer.totalMeses
                  ? contratosEntePrivadoReducer.totalMeses.toString()
                  : '0'}
              </div>
            </Col>
          </Row>

          <Row>
            <Col cols={[12, 12, 6, 6, 6]}>
              <CustomCheckbox
                id={'analise-juridica'}
                className={'componentsDescentralizado__analise-juridica'}
                label={languageValues.flgAnaliseJuridicaAceite}
                name='flgAnaliseJuridica'
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  handleDataChange('flgAnaliseJuridica', event.target.checked);
                }}
                checked={contratosEntePrivadoReducer.flgAnaliseJuridica}
                disabled={
                  !isContratoAtivoEntePrivado() ||
                  !validaStatusContratoFluxo()}
              />
            </Col>
          </Row>
        </Box>
      </Card>
    </Container>
  );
};





